import React, { useState, useEffect, useRef } from "react"
import { Container, Row, Col, Button, Card, CardBody } from "reactstrap"
import axios from "axios"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Dialog } from "primereact/dialog"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { ConfirmDialog } from "primereact/confirmdialog"
import { FileUpload } from "primereact/fileupload"
import { InputNumber } from "primereact/inputnumber"
import { InputTextarea } from "primereact/inputtextarea"
import { TreeSelect } from "primereact/treeselect"
import { Controller, useForm } from "react-hook-form"
import Select from "react-select"
import { formatDateTime, triggerAlert } from "utils/CommonFunctions"
import {
  emailValidation,
  MaxLengthValidation,
  MinLengthValidation,
  onlyNumbers,
} from "utils/Constants"
import "primereact/resources/themes/lara-light-indigo/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Checkbox } from "primereact/checkbox"
import { useWatch } from "react-hook-form"
import { ProgressSpinner } from "primereact/progressspinner"

const CandidateEditFormExtra = () => {
  const [fullNameDialogVisible, setFullNameDialogVisible] = useState(false)
  const prevStateIdRef = useRef();
  const statesCacheRef = useRef({});
  const citiesCacheRef = useRef({});

  const [totalExperience, setTotalExperience] = useState(null)
  const [address, setAddress] = useState("")
  const [currentSalary, setCurrentSalary] = useState(null)
  const [expectedSalary, setExpectedSalary] = useState(null)
  const [educationDetails, setEducationDetails] = useState([])
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [deleteWorkVisible, setDeleteWorkVisible] = useState(false)
  const [workToDelete, setWorkToDelete] = useState(null)
  const [deleteEduVisible, setDeleteEduVisible] = useState(false)
  const [eduToDelete, setEduToDelete] = useState(null)
  const [editEduIndex, setEditEduIndex] = useState(null)
  const [primarySkillsview, setPrimarySkillsview] = useState(null)
  const [categoryNodes, setCategoryNodes] = useState([])
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null)
  const [groupNodes, setGroupNodes] = useState([])
  const [selectedGroupNode, setSelectedGroupNode] = useState(null)
  const [documentTypes, setDocumentTypes] = useState([])
  const [uniqueUserId, setUniqueUserId] = useState("")
  const [candidateCountryId, setCandidateCountryId] = useState(null)
  const [candidateStateId, setCandidateStateId] = useState(null)
  const [candidateCityId, setCandidateCityId] = useState(null)
  const [candidateDetails, setCandidateDetails] = useState(null)
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([])
  const [companyOptions, setCompanyOptions] = useState([]);
  const [addressLabels, setAddressLabels] = useState([]);
  const [candidateAddressLabel, setCandidateAddressLabel] = useState(null);
const [referredByOptions, setReferredByOptions] = useState([]);
const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);

  // Fetch API options
useEffect(() => {
  const fetchReferredBy = async () => {
    try {
      const response = await axios.get(
        "/api/v1/get-all-referred-by/"
      );
      const options = response.data.results.map(item => ({
        label: item.value,  // what user sees
        value: item.id       // what we send in payload
      }));
      setReferredByOptions(options);
    } catch (error) {
      console.error("Failed to fetch referred by options", error);
    }
  };

  fetchReferredBy();
}, []);

  // email check 
  const [isDuplicateEmail, setIsDuplicateEmail] = useState(false);
const [duplicateCandidateId, setDuplicateCandidateId] = useState(null);
const [emailError, setEmailError] = useState("");

const handleEmailBlur = async (e) => {
  const email = e.target.value?.trim().toLowerCase();
  setIsDuplicateEmail(false);
  setDuplicateCandidateId(null);
  setEmailError("");

  if (!email) return;

  try {
    const response = await axios.post(
      "/api/v1/candidates/check-email/",
      { email }
    );
    if (response.data.duplicate) {
      setIsDuplicateEmail(true);
      setDuplicateCandidateId(response.data.candidate_id);
      setEmailError("Candidate with this email already exists.");
    }
  } catch (err) {
    setIsDuplicateEmail(false);
    setDuplicateCandidateId(null);
    setEmailError("Failed to check duplicate email.");
  }
};
  

  const years = Array.from({ length: 50 }, (_, i) => {
    const year = new Date().getFullYear() - i
    return { label: year.toString(), value: year.toString() }
  })
  const inputRef = useRef(null)

  const months = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ]

  const [visible, setVisible] = useState(false)
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [selectedLabel1, setSelectedLabel1] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [addCountries, setAddCountries] = useState([])
  const [addStates, setAddStates] = useState([])
  const [addCities, setAddCities] = useState([])

  const labels = [
    { name: "Work From Office", code: "Work From Office" },
    { name: "Work From Home", code: "Work From Home" },
    { name: "Work From Remote", code: "Work From Remote" },
  ]

  const [basicimp, setBasicimp] = useState("")
  const [basictittle, setBasictittle] = useState("")
  const [basicfirst, setBasicfirst] = useState("")
  const [basicmiddle, setBasicmiddle] = useState("")
  const [basiclast, setBasiclast] = useState("")
  // ...existing code...
const [tempStreet1, setTempStreet1] = useState("");
const [tempStreet2, setTempStreet2] = useState("");
const [tempPostalCode, setTempPostalCode] = useState("");
const [tempSelectedCountry, setTempSelectedCountry] = useState(null);
const [tempSelectedState, setTempSelectedState] = useState(null);
const [tempSelectedCity, setTempSelectedCity] = useState(null);
const [tempSelectedLabel1, setTempSelectedLabel1] = useState(null);
// ...existing code...

  const groupedItemTemplate = option => (
    <div className="flex align-items-center">
      <i className="pi pi-file mr-2"></i>
      <div>{option.label}</div>
    </div>
  )

  const [groupitem, setGroupitem] = useState([])
  const [selectedGroupKey, setSelectedGroupKey] = useState(null)
  const [workExperiences, setWorkExperiences] = useState([])
  const [showDialog, setShowDialog] = useState(false)
  const [formValues, setFormValues] = useState({
    company_name: "",
    website: "",
    job_title: "",
    start_date: "",
    end_date: "",
    description: "",
  })
  const [editIndex, setEditIndex] = useState(null)

  const navigate = useNavigate()
  const location = useLocation()
  const [pathSegment, setPathSegment] = useState(null)
  const [error, setError] = useState("")
  const [primarySkillsget, setPrimarySkillsget] = useState([])
  const [categoriesitem, setCategoriesitem] = useState([])
  const [documents, setDocuments] = useState([])
  const [displayDialog, setDisplayDialog] = useState(false)
  const [fileData, setFileData] = useState(null)
  const [sourceOptions, setSourceOptions] = useState([])

  const userInfo = JSON.parse(sessionStorage.getItem("userinfoCookie") || "{}")
  const userId = userInfo?.user_details?.user_id || ""

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    watch,
    getValues: getValuesWork,
    control,
  } = useForm({
    defaultValues: {
      created_at: new Date(),
      updated_at: new Date(),
      last_activity_date: null,
      last_activity_type: null,
      created_by: userId,
      first_name: "",
      last_name: "",
      current_company: "",
      status: "",
      total_experience: null,
      email: "",
      email_1: "",
      mobile_phone: "",
      work_phone: "",
      primary_skills: [],
      secondary_skills: [],
      other_skills: [],
      current_salary: null,
      expected_salary: null,
      employee_type: "",
      dob: null,
      relocation: false,
      job_title: "",
      availability_date: null,
      referred_by: "",
      source: "",
      categories: null,
      groups: null,
      linkedin_url: "",
      facebook_url: "",
      x_url: "",
      indeed_url: "",
      notes: "",
    },
  })
  useEffect(() => {
  trigger("mobile_phone");
}, [watch("mobile_phone")]);
  

const fetchAddressLabels = async () => {
  try {
    const response = await axios.get("/api/v1/get-all-address-label/");
    if (response?.data?.results) {
      const labels = response.data.results.map(label => ({
        label: label.address_label, // e.g., "Current Address"
        value: label.id, // Use the ID as the value
      }));
      setAddressLabels(labels);
    }
  } catch (error) {
    console.error("Error fetching address labels:", error);
  }
};


  const getEmployeeTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-employee-type/")
      if (response.data?.results) {
        setEmployeeTypeOptions(
          response.data.results.map(item => ({
            label: item.employee_type,
            value: item.id,
          }))
        )
      }
    } catch (error) {
      console.error("Error fetching employee types:", error)
    }
  }

  const getDocumentTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-document-type/")
      if (response.data?.results) {
        const transformedData = response.data.results.map(doc => ({
          label: doc.value,
          value: doc.id, // Use unique ID for value
        }))
        setDocumentTypes(transformedData)
      }
    } catch (error) {
      console.error("Error fetching document types:", error)
      triggerAlert("error", "Error", "Failed to fetch document types.")
    }
  }

  const {
    register: registerDoc,
    handleSubmit: handleSubmitDoc,
    reset: resetDocForm,
    control: controlDoc,
    formState: { errors: errorsDoc },
  } = useForm({
    defaultValues: {
      selected_document: null,
      subject: "",
      file: null,
    },
  })

  const {
    register: registerWork,
    handleSubmit: handleSubmitWork,
    reset: resetWork,
    control: controlWork,
    formState: { errors: errorsWork },
  } = useForm({
    defaultValues: {
      company_name: "",
      website: "",
      job_title: "",
      start_date: null,
      end_date: null,
    },
  })

  const {
    control: eduControl,
    handleSubmit: handleSubmitEdu,
    reset: resetEduForm,
    getValue: getValueEdu,
    watch: watchEdu,
    formState: { errors: eduErrors },
  } = useForm({
    defaultValues: {
      school_name: "",
      degree: "",
      field_of_study: "",
      start_year: null,
      start_month: null,
      end_year: null,
      end_month: null,
      grade: "",
    },
  })

  const watchedStartDate = useWatch({
    control: controlWork,
    name: "start_date",
  })

  const groupedDocuments = [
    {
      label: "Proof of Identity",
      items: [
        { label: "Aadhaar Card", value: "Aadhaar Card" },
        { label: "Passport", value: "Passport" },
        { label: "Voter ID", value: "Voter ID" },
        { label: "PAN Card", value: "PAN Card" },
        { label: "Driver's License", value: "Driver's License" },
      ],
    },
  ]

  const selectedCategoryKey = watch("category")

  useEffect(() => {
    const updatenamesbasic = [basictittle, basicfirst, basicmiddle, basiclast]
      .filter(Boolean)
      .join(" ")
    setBasicimp(updatenamesbasic)
  }, [basictittle, basicfirst, basicmiddle, basiclast])

  useEffect(() => {
  setIsDuplicateEmail(false);
  setDuplicateCandidateId(null);
  setEmailError("");
}, [pathSegment]);

useEffect(() => {
  const fetchInitialData = async () => {
    try {
      setIsPageLoading(true);
      // Fetch address labels first
      await fetchAddressLabels();
      // Fetch other data
      await Promise.all([
        getCategories(),
        getGroups(),
        getCategoriesitem(),
        getSkills(),
        getAddCountries(),
        getResumeSources(),
        getDocumentTypes(),
        getCompanies(),
        getEmployeeTypes(),
      ]);

      // Fetch candidate data if pathSegment exists
      const url = new URL(window.location.href);
      const candidateIdFromQuery = url.searchParams.get("candidate_id");
      if (candidateIdFromQuery) {
        setPathSegment(candidateIdFromQuery);
        await geteditvaluescondidates(candidateIdFromQuery);
      }

      const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
      if (userInfo && userInfo.user_details) {
        setUniqueUserId(userInfo.user_details.unique_user_id);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
     finally {
      setIsPageLoading(false);
    }
  };

  fetchInitialData();
}, [location.search]);

  const mapAttachmentsToDocuments = (attachments, documentTypes) => {
    return attachments.map(item => {
      const fileName = item.file_name || "unknown"
      const fileUrl = item.file_url || ""
      const extension = fileName.split(".").pop().toLowerCase()

      const mimeTypes = {
        pdf: "application/pdf",
        doc: "application/msword",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
      }

      const fileType = mimeTypes[extension] || "application/octet-stream"

      const matchedDocumentType = documentTypes.find(
        doc =>
          doc.label?.toLowerCase().replace(/\s+/g, "") ===
          item.document_type?.toLowerCase().replace(/\s+/g, "")
      )

      return {
        selected_document: matchedDocumentType || {
          label: item.document_type || "",
          value: item.document_type || "",
        },
        subject: item.document_subject || "-",
        file: {
          name: fileName,
          type: fileType,
          url: fileUrl,
        },
        isNew: false,
      }
    })
  }
  //   useEffect(() => {
  //   if (pathSegment && primarySkillsget.length > 0 && employeeTypeOptions.length > 0) {
  //     // Re-fetch candidate data or use a stored state to set skills
  //     const setSkillsData = async () => {
  //       try {
  //         const response = await axios.get(`/api/v1/candidates/${pathSegment}/`)
  //         if (response.status === 200) {
  //           const results = response.data
  //                 const employeeTypeOption = employeeTypeOptions.find(
  //       opt => opt.label === results.employee_type
  //     );
  //     setValue("employee_type", employeeTypeOption ? employeeTypeOption.value : "");

  //           // Map skill IDs to skill objects for react-select
  //           const mapSkills = skillIds =>
  //             Array.isArray(skillIds)
  //               ? primarySkillsget.filter(opt => skillIds.includes(opt.id))
  //               : []

  //           setValue("primary_skills", mapSkills(results.primary_skills) || [])
  //           setValue(
  //             "secondary_skills",
  //             mapSkills(results.secondary_skills) || []
  //           )
  //           setValue("other_skills", mapSkills(results.other_skills) || [])

  //           const workDetails = results.work_details || []
  //           const educationDetails = results.education_details || []
  //           const documentDetails = results.attachments || []

  //           const transformedWorkExperiences = workDetails.map(item => ({
  //             company_name: item.company_name || "-",
  //             website: item.website || "",
  //             job_title: item.job_title || "",
  //             start_date: item.start_date || "",
  //             end_date: item.end_date || "",
  //           }))

  //           const transformededucationDetails = educationDetails.map(item => ({
  //             degree: item.degree || "-",
  //             school_name: item.school_name || "-",
  //             field_of_study: item.field_of_study || "-",
  //             start_year: item.start_year || "-",
  //             start_month: item.start_month || "-",
  //             end_year: item.end_year || "-",
  //             end_month: item.end_month || "-",
  //           }))
  //           const documentData = mapAttachmentsToDocuments(
  //             documentDetails,
  //             documentTypes
  //           )
  //           setDocuments(documentData)

  //           setEducationDetails(transformededucationDetails)

  //           setWorkExperiences(transformedWorkExperiences)
  //         }
  //       } catch (error) {
  //         console.error("Error setting skills:", error)
  //       }
  //     }

  //     setSkillsData()
  //   }
  // }, [pathSegment, primarySkillsget, setValue])

  useEffect(() => {
    if (!candidateDetails || primarySkillsget.length === 0) return;

    const employeeTypeOption = employeeTypeOptions.find(
      opt => opt.label === candidateDetails.employee_type
    );
    setValue("employee_type", employeeTypeOption ? employeeTypeOption.value : "");

    const mapSkills = skillIds =>
      Array.isArray(skillIds)
        ? primarySkillsget.filter(opt => skillIds.includes(opt.id))
        : [];

    setValue("primary_skills", mapSkills(candidateDetails.primary_skills) || []);
    setValue("secondary_skills", mapSkills(candidateDetails.secondary_skills) || []);
    setValue("other_skills", mapSkills(candidateDetails.other_skills) || []);

    const transformedWorkExperiences = (candidateDetails.work_details || []).map(item => ({
      company_name: item.company_name || "-",
      website: item.website || "",
      job_title: item.job_title || "",
      start_date: item.start_date || "",
      end_date: item.end_date || "",
    }));

    const transformededucationDetails = (candidateDetails.education_details || []).map(item => ({
      degree: item.degree || "-",
      school_name: item.school_name || "-",
      field_of_study: item.field_of_study || "-",
      start_year: item.start_year || "-",
      start_month: item.start_month || "-",
      end_year: item.end_year || "-",
      end_month: item.end_month || "-",
    }));

    setDocuments(mapAttachmentsToDocuments(candidateDetails.attachments || [], documentTypes));
    setEducationDetails(transformededucationDetails);
    setWorkExperiences(transformedWorkExperiences);
  }, [candidateDetails, primarySkillsget, employeeTypeOptions, documentTypes, setValue])

  const getCompanies = async () => {
  try {
    const response = await axios.get("/api/v1/get-all-companies/");
    if (response.data?.results) {
      setCompanyOptions(
        response.data.results.map(company => ({
          label: company.name, // or company.company_name
          value: company.company_id, // or company.id
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching companies:", error);
  }
};

  const onSubmitDoc = data => {
    const selectedDocType = documentTypes.find(
      doc => doc.value === data.selected_document
    )

    const enrichedData = {
      ...data,
      selected_document: selectedDocType, // <-- Store label and value
      isNew: true,
    }

    setDocuments([...documents, enrichedData])
    resetDocForm()
    closeAddDocumentDialog()
  }
useEffect(() => {
  if (candidateAddressLabel && addressLabels.length > 0) {
    const foundLabel = addressLabels.find(l => l.label === candidateAddressLabel);
    setSelectedLabel1(foundLabel ? foundLabel.value : null);
  }
}, [candidateAddressLabel, addressLabels]);
  useEffect(() => {
    const labelObj = addressLabels.find(l => l.value === selectedLabel1);
    setAddress(
      [
        street1,
        street2,
        selectedCity?.name,
        selectedState?.name,
        selectedCountry?.name,
        postalCode,
        labelObj?.label
      ]
        .filter(Boolean)
        .join(",\n ")
    )
  }, [
    street1,
    street2,
    selectedCity,
    selectedState,
    selectedCountry,
    postalCode,
    selectedLabel1,
    addressLabels
  ])

  useEffect(() => {
    if (selectedCategoryKey) {
      getGroupsitemsub(selectedCategoryKey)
    }
  }, [selectedCategoryKey])

  useEffect(() => {
  if (selectedCountry?.id) {
    getAddStates(selectedCountry.id);
    // Reset state and city when country changes
    setSelectedState(null);
    setSelectedCity(null);
    setAddStates([]);
    setAddCities([]);
  }
}, [selectedCountry]);

  // Fetch cities when selectedState changes
useEffect(() => {
  if (selectedState?.id) {
    getAddCities(selectedState.id);
    // Reset city when state changes
     if (prevStateIdRef.current !== selectedState.id) {
      setSelectedCity(null);
      setAddCities([]);
    }
    prevStateIdRef.current = selectedState.id;
  }
}, [selectedState]);
useEffect(() => {
  if (tempSelectedCountry?.id) {
    getAddStates(tempSelectedCountry.id);
    setTempSelectedState(null);
    setTempSelectedCity(null);
    setAddStates([]);
    setAddCities([]);
  }
}, [tempSelectedCountry]);
useEffect(() => {
  if (tempSelectedState?.id) {
    getAddCities(tempSelectedState.id);
    setTempSelectedCity(null);
    setAddCities([]);
  }
}, [tempSelectedState]);


  useEffect(() => {
    register("dob", {
      validate: {
        validFormat: value =>
          !value ||
          /^\d{4}-\d{2}-\d{2}$/.test(formatDateTime(value, "yyyy-mm-dd")) ||
          "Date of Birth must be in YYYY-MM-DD format",
      },
    })
    register("last_activity_date", {
      validate: {
        validFormat: value =>
          !value ||
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{6})?)?([+-]\d{2}:\d{2}|Z)?$/.test(
            formatDateTime(value, "yyyy-mm-ddThh:mm:ssZ")
          ) ||
          "Last Activity Date must be in YYYY-MM-DDThh:mm:ssZ format",
      },
    })
  }, [register])

  const getMimeType = url => {
    const extension = url.split(".").pop().toLowerCase()

    const mimeTypes = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      txt: "text/plain",
    }

    return mimeTypes[extension] || "application/octet-stream" // fallback
  }
const geteditvaluescondidates = async id => {
  try {
    const response = await axios.get(`/api/v1/candidates/${id}/`);
    if (response.status === 200) {
      const results = response.data;
      setCandidateDetails(results);

      // Parse dates
      const parsedData = {
        ...results,
        availability_date: results.availability_date ? new Date(results.availability_date) : null,
        dob: results.dob ? new Date(results.dob) : null,
        created_at: results.created_at ? new Date(results.created_at) : new Date(),
        updated_at: results.updated_at ? new Date(results.updated_at) : new Date(),
        last_activity_date: results.last_activity_date ? new Date(results.last_activity_date) : null,
        notes: results.candidate_notes || "",
      };

      // Set form values except skills
      Object.keys(parsedData).forEach(key => {
        if (!["primary_skills", "secondary_skills", "other_skills"].includes(key)) {
          setValue(key, parsedData[key]);
        }
      });

      // Set resume if it exists
      if (results.resume) {
        const fileName = results.resume.split("/").pop();
        const mimeType = getMimeType(results.resume);
        setFileData({
          name: fileName,
          type: mimeType,
          base64: results.resume,
        });
      } else {
        setFileData(null);
      }

      // Set address-related fields
      setStreet1(results.street_address || "");
      setStreet2(results.street_address_line_2 || "");
      setPostalCode(results.pincode || "");
      setSelectedCategoryNode(results.categories || null);
      setSelectedGroupNode(results.groups || null);
      setCandidateCountryId(results.country || null);
      setCandidateStateId(results.state || null);
      setCandidateCityId(results.city || null);

      // Set address label
      if (results.address_label) {
  setCandidateAddressLabel(results.address_label);
} else {
  setCandidateAddressLabel(null);
}

      // Set country, state, city
      if (results.country) {
        const selectedCountryObj = addCountries.find(item => item.id === results.country);
        setSelectedCountry(selectedCountryObj || null);
      }
      if (results.state) {
        const selectedStateObj = addStates.find(item => item.id === results.state);
        setSelectedState(selectedStateObj || null);
      }
      if (results.city) {
        const selectedCityObj = addCities.find(item => item.id === results.city);
        setSelectedCity(selectedCityObj || null);
      }

      // Update address field
      setAddress(
        [
          results.street_address,
          results.street_address_line_2,
          results.city_name,
          results.state_name,
          results.country_name,
          results.pincode,
          results.address_label, // Include address_label directly from API
        ]
          .filter(Boolean)
          .join(", ")
      );

      setPrimarySkillsview(results.primary_skills || null);

      // Set employee type
      const employeeTypeOption = employeeTypeOptions.find(opt => opt.label === results.employee_type);
      setValue("employee_type", employeeTypeOption ? employeeTypeOption.value : "");
    }
  } catch (error) {
    console.error("Error fetching candidate:", error);
  }
};

  const getResumeSources = async () => {
    try {
      const response = await axios.get(`/api/v1/resume-source/`)
      const transformedData = response.data.results.map(workv => ({
        label: workv.resume_source,
        value: workv.source_id,
      }))
      setSourceOptions(transformedData)
    } catch (error) {
      console.error("Error fetching resume sources:", error)
    }
  }

  const getSkills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`)
      const transformedData = response.data.results.map(workv => ({
        id: workv.skill_id,
        name: workv.skill_name,
      }))
      setPrimarySkillsget(transformedData)
    } catch (error) {
      console.error("Error fetching skills:", error)
    }
  }
  const getCategoriesitem = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response.data?.results) {
        const transformedData = response.data.results.map(category => ({
          name: category.name,
          id: category.category_id,
        }))
        setCategoriesitem(transformedData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  const getGroupsitemsub = async category_ids => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-groups/?category_id=${category_ids}`
      )
      if (response.data?.results) {
        const transformedDatagroup = response.data.results.map(group => ({
          name: group.name,
          id: group.group_id,
        }))
        setGroupitem(transformedDatagroup)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }

  const getAddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`)
      const transformedData = response.data.results.map(country => ({
        name: country.name,
        id: country.country_id,
      }))
      setAddCountries(transformedData)
    } catch (error) {
      console.error("Error fetching countries:", error)
    }
  }

  const getAddStates = async countryId => {
    try {
      if (statesCacheRef.current[countryId]) {
        setAddStates(statesCacheRef.current[countryId])
        return statesCacheRef.current[countryId]
      }

      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`
      )
      const transformedData = response.data.results.map(state => ({
        name: state.name,
        id: state.state_id,
      }))
      statesCacheRef.current[countryId] = transformedData
      setAddStates(transformedData)
      return transformedData
    } catch (error) {
      console.error("Error fetching states:", error)
      return []
    }
  }

  const getAddCities = async stateId => {
    try {
      if (citiesCacheRef.current[stateId]) {
        setAddCities(citiesCacheRef.current[stateId])
        return citiesCacheRef.current[stateId]
      }

      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`
      )
      const transformedData = response.data.results.map(city => ({
        name: city.name,
        id: city.city_id,
      }))
      citiesCacheRef.current[stateId] = transformedData
      setAddCities(transformedData)
      return transformedData
    } catch (error) {
      console.error("Error fetching cities:", error)
      return []
    }
  }

  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result.split(",")[1])
      reader.onerror = error => reject(error)
    })
  }

  const handleFileChange = async event => {
    const file = event.target.files[0]
    if (!file) return
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ]
    if (!allowedTypes.includes(file.type)) {
      setError(
        "Only PDF, Word (doc, docx), and image (jpg, jpeg, png) files are allowed."
      )
      return
    }
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
      setError("File size should not exceed 5MB.")
      return
    }
    setError("")
    try {
      const base64 = await getBase64(file)
      console.log("Base64:", base64)
      setFileData({
        name: file.name,
        type: file.type,
        base64,
      })
    } catch (error) {
      console.error("Error converting file to base64:", error)
      setError("Error converting file to base64.")
    }
  }

  const openAddDocumentDialog = () => setDisplayDialog(true)
  const closeAddDocumentDialog = () => setDisplayDialog(false)

  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories
        ? category.subcategories.map(buildTree)
        : [],
    })
    return categories.map(buildTree)
  }

  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups.map(buildTree) : [],
    })
    return groups.map(buildTree)
  }

  const getCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response.data?.results) {
        const treeData = transformCategoriesToTree(response.data.results)
        setCategoryNodes(treeData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  const getGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response.data?.results) {
        const groupTree = transformGroupsToTree(response.data.results)
        setGroupNodes(groupTree)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }
  console.log("educationDetails", educationDetails)
  const onSubmit = async data => {
    const isValid = await trigger()
    if (!isValid) {
      triggerAlert(
        "error",
        "Validation Error",
        "Please correct the errors in the form."
      )
      return
    }
    if (isDuplicateEmail) {
    triggerAlert("error", "Validation Error", "Candidate with this email already exists.");
    return;
  }

    try {
      setIsLoading(true)
      const payload = {
        ...data,
        // resume: fileData?.base64,
        resume: fileData
          ? {
              file_name: fileData.name,
              file_data: fileData.base64,
            }
          : null,
        street_address: street1 || undefined,
        street_address_line_2: street2 || undefined,
        state: selectedState?.id || undefined,
        city: selectedCity?.id || undefined,
        country: selectedCountry?.id || undefined,
        pincode: postalCode || undefined,
        label: selectedLabel1 || undefined,
        address_label: selectedLabel1 || undefined,
        employee_type: data.employee_type || undefined,
        categories: selectedCategoryNode || undefined,
        groups: selectedGroupNode || undefined,
        primary_skills: data.primary_skills?.map(skill => skill.id) || [],
        secondary_skills: data.secondary_skills?.map(skill => skill.id) || [],
        other_skills: data.other_skills?.map(skill => skill.id) || [],
        created_at: formatDateTime(data.created_at, "yyyy-mm-dd hh:mm:ss"),
        updated_at: formatDateTime(data.updated_at, "yyyy-mm-dd hh:mm:ss"),
        current_salary:
          isNaN(data.current_salary) ||
          data.current_salary == null ||
          data.current_salary === ""
            ? 0.0
            : Number(data.current_salary).toFixed(2),
        expected_salary:
          isNaN(data.expected_salary) ||
          data.expected_salary == null ||
          data.expected_salary === ""
            ? 0.0
            : Number(data.expected_salary).toFixed(2),
        last_activity_date: data.last_activity_date
          ? `${formatDateTime(data.last_activity_date, "yyyy-mm-dd")}T00:00:00Z`
          : undefined,
        candidate_notes: data.notes || "",
        documents:
          documents
            .filter(doc => doc.isNew) // Only include new documents
            .map(doc => ({
              type: doc.selected_document?.label,
              subject: doc.subject,
              file: doc.file?.base64,
              file_name: doc.file?.name,
            })) || [],
        work_details:
          workExperiences?.map(exp => ({
            company_name: exp.company_name,
            website: exp.website,
            job_title: exp.job_title,
            start_date: exp.start_date
              ? formatDateTime(exp.start_date, "yyyy-mm-dd")
              : "",
            end_date: exp.end_date
              ? formatDateTime(exp.end_date, "yyyy-mm-dd")
              : "",
          })) || [],
        educations:
          educationDetails?.map(edu => ({
            ...edu,
            start_year: edu.start_year || "",
            start_month: edu.start_month || "",
            end_year: edu.end_year || "",
            end_month: edu.end_month || "",
          })) || [],
        dob: data.dob ? formatDateTime(data.dob, "yyyy-mm-dd") : undefined,
        availability_date: data.availability_date
          ? formatDateTime(data.availability_date, "yyyy-mm-dd")
          : undefined,
      }

      const endpoint = pathSegment
        ? `/api/v1/candidates/${pathSegment}/`
        : `/api/v1/candidates/`
      const method = pathSegment ? "patch" : "post"
      const successCode = pathSegment ? 200 : 201

      const response = await axios[method](endpoint, payload)
      if (response.status === successCode) {
        triggerAlert("success", "Success", "Candidate Updated Successfully.")
        navigate("/all_candidates")
      } else {
        triggerAlert(
          "error",
          "Error",
          "Failed to update candidate. Please try again."
        )
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      if (error.response?.data?.details) {
        // const errorMessages = Object.entries(error.response.data.details)
        //   .map(([field, messages]) => `${field}: ${messages?.join(", ")}`)
        //   .join("; ");
        const details = error.response.data.details
        const errorMessages = Object.entries(details)
          .map(
            ([field, messages]) =>
              `${field}: ${
                Array.isArray(messages) ? messages.join(", ") : messages
              }`
          )
          .join("; ")
        triggerAlert("error", "Validation Error", errorMessages)
      } else {
        triggerAlert(
          "error",
          "Error",
          "Failed to update candidate. Please try again."
        )
      }
    } finally {
      setIsLoading(false)
    }
  }

  // sais code

  useEffect(() => {
    if (
      visible &&
      addCountries.length &&
      addStates.length &&
      addCities.length &&
      pathSegment
    ) {
      // Get candidate data from form or state
      const candidateCountryId = getValuesWork("country") || selectedCountry?.id
      const candidateStateId = getValuesWork("state") || selectedState?.id
      const candidateCityId = getValuesWork("city") || selectedCity?.id

      if (candidateCountryId) {
        const foundCountry = addCountries.find(c => c.id === candidateCountryId)
        if (foundCountry) setSelectedCountry(foundCountry)
      }
      if (candidateStateId) {
        const foundState = addStates.find(s => s.id === candidateStateId)
        if (foundState) setSelectedState(foundState)
      }
      if (candidateCityId) {
        const foundCity = addCities.find(c => c.id === candidateCityId)
        if (foundCity) setSelectedCity(foundCity)
      }
    }
  }, [visible, addCountries, addStates, addCities, pathSegment])

  useEffect(() => {
    if (candidateCountryId && addCountries.length) {
      const foundCountry = addCountries.find(c => c.id === candidateCountryId)
      if (foundCountry) setSelectedCountry(foundCountry)
    }
  }, [candidateCountryId, addCountries])

  useEffect(() => {
    if (candidateStateId && addStates.length) {
      const foundState = addStates.find(s => s.id === candidateStateId)
      if (foundState) setSelectedState(foundState)
    }
  }, [candidateStateId, addStates])

  useEffect(() => {
    if (candidateCityId && addCities.length) {
      const foundCity = addCities.find(c => c.id === candidateCityId)
      if (foundCity) setSelectedCity(foundCity)
    }
  }, [candidateCityId, addCities])

  // ...existing code...

useEffect(() => {
  if (visible) {
    // Always set temp fields from main state when modal opens
    setTempStreet1(street1);
    setTempStreet2(street2);
    setTempPostalCode(postalCode);
    setTempSelectedCountry(selectedCountry);

    // If country is selected, fetch states
    if (selectedCountry?.id) {
      getAddStates(selectedCountry.id).then(states => {
        // After states are loaded, set temp state
        const foundState = states.find(s => s.id === selectedState?.id);
        setTempSelectedState(foundState || null);

        // If state is selected, fetch cities
        if (selectedState?.id) {
          getAddCities(selectedState.id).then(cities => {
            const foundCity = cities.find(c => c.id === selectedCity?.id);
            setTempSelectedCity(foundCity || null);
          });
        } else {
          setTempSelectedCity(null);
        }
      });
    } else {
      setTempSelectedState(null);
      setTempSelectedCity(null);
    }

    setTempSelectedLabel1(selectedLabel1);
  }
  // Only run when modal is opened
  // eslint-disable-next-line
}, [visible]);

const removeDocument = (index) => {
  const updatedDocuments = documents.filter((_, i) => i !== index);
  setDocuments(updatedDocuments);
};

// ...existing code...
const [isPageLoading, setIsPageLoading] = useState(true);

  return (
    <React.Fragment>
       {isPageLoading ? (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <ProgressSpinner />
      </div>
    ) :(
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={6}>
                <h1 className="page-title">
                  {pathSegment ? "Edit" : "Create"} a Candidate
                </h1>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    {pathSegment ? "Edit" : "Add"} a candidate by entering their details, skills, and contact information to streamline recruitment.
                  </li>
                </ol>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2"
                    onClick={handleSubmit(onSubmit)}
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save"}
                  </Button>
                  <Link to="/all_candidates">
                    <Button
                      color="secondary"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Cancel <i className="pi pi-times me-1"></i>
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col xl={4}>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Basic Information</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">
                              First Name <span className="text-danger">*</span>
                            </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("first_name", {
                                required: "First name is required ",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                  message:
                                    "Only alphabets, spaces, and hyphens allowed. Cannot start with a space.",
                                },
                              })}
                              onKeyUp={() => trigger("first_name")}
                            />
                            {errors.first_name && (
                              <small className="text-danger">
                                {errors.first_name.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Last Name</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("last_name")}
                              onKeyUp={() => trigger("last_name")}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Company</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("current_company", {
                                minLength: {
                                  value: 2,
                                  message: "Please enter a valid company name."
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Please enter a valid company name."
                                },
                                pattern: {
                                  value: /^[A-Za-z0-9\s&.\-]+$/,
                                  message: "Please enter a valid company name."
                                }
                              })}
                              onKeyUp={() => trigger("current_company")}
                            />
                            {errors.current_company && (
                              <small className="text-danger">
                                {errors.current_company.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Job Title</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("job_title")}
                              onKeyUp={() => trigger("job_title")}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Status</label>
                          </Col>
                          <Col xl={9}>
                            <select
                              className="form-select w-full"
                              {...register("status")}
                            >
                              <option value="" hidden>
                                Select
                              </option>
                              <option value='Active'>Active</option>
                <option value='InActive'>InActive</option>
                <option value='DND(Do Not Disturb)'>DND(Do Not Disturb)</option>
                <option value='Blacklisted'>Blacklisted</option>
                <option value='Opt-Out'>Opt Out</option>
                            </select>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="total_experience"
                              className="block mb-2"
                            >
                              Total Experience <span className="text-danger">*</span>
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
      name="total_experience"
      control={control}
      rules={{
        required: "Total experience is required",
        min: {
          value: 0,
          message: "Total experience cannot be negative",
        },
      }}
      render={({ field, fieldState }) => (
        <>
          <InputNumber
            inputId="total_experience"
            value={field.value}
            onValueChange={e => field.onChange(e.value < 0 ? 0 : e.value)}
            min={0}
            minFractionDigits={1}
            maxFractionDigits={1}
            mode="decimal"
            placeholder="Years of experience"
            className="w-full"
          />
          {fieldState.error && (
            <small className="text-danger">
              {fieldState.error.message}
            </small>
          )}
        </>
      )}
    />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Contact Information</h4>
                    <Row>
                      <Col xl={12}>
<Row className="mt-2 align-items-center">
  <Col xl={3}>
    <label className="block mb-2">
      Email <span className="text-danger">*</span>
    </label>
  </Col>
  <Col xl={9}>
    <InputText
      className="w-full"
      {...register("email", {
        required: "Email is required ",
        pattern: emailValidation,
      })}
      onChange={async e => {
        const email = e.target.value.toLowerCase();
        setValue("email", email, { shouldValidate: true });

        // Duplicate email check on change
        setIsDuplicateEmail(false);
        setDuplicateCandidateId(null);
        setEmailError("");
        if (!email) return;
        try {
          const response = await axios.post(
            `/api/v1/candidates/check-email/?company_id=${companyId}`,
            { email }
          );
          if (response.data.duplicate) {
            setIsDuplicateEmail(true);
            setDuplicateCandidateId(response.data.candidate_id);
            setEmailError("Candidate with this email already exists.");
            setError("email", {
                type: "manual",
                message: "Candidate with this email already exists.",
          })
        } else {
          clearErrors("email")
        
        }
        } catch (err) {
          setIsDuplicateEmail(false);
          setDuplicateCandidateId(null);
          setEmailError("Failed to check duplicate email.");
        }
      }}
    />
    {emailError && (
      <small className="text-danger">{emailError}</small>
    )}
    {isDuplicateEmail && duplicateCandidateId && (
      <Button
        className="btn btn-warning ms-2"
        onClick={() => navigate(`/candidate-editform?candidate_id=${duplicateCandidateId}`)}
      >
        Edit Candidate
      </Button>
    )}
    {errors.email && (
      <small className="text-danger">
        {errors.email.message}
      </small>
    )}
  </Col>
</Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">
                              Secondary Email
                            </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("email_1")}
                              onChange={e => e.target.value.toLowerCase()}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Work Phone </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("work_phone", {
                                pattern: {
                                  value: onlyNumbers,
                                  message: "Only numbers are allowed",
                                },
                                minLength: MinLengthValidation(10),
                                maxLength: MaxLengthValidation(14),
                                // validate: {
                                //   notAllZeros: value =>
                                //     !/^0+$/.test(value) ||
                                //     "Work Phone cannot be all zeros",
                                //   exactLength: value =>
                                //     value.length === 10 ||
                                //     "Work Phone must be exactly 10 digits",
                                // },
                              })}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">
                              Mobile Phone{" "}
                              <span className="text-danger">*</span>
                            </label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("mobile_phone", {
                                required: "Mobile phone is required ",
                                pattern: {
                                  value:
                                    /^(\+?\d{1,4}[-.\s]?)?(\(?\d{1,5}\)?[-.\s]?)?\d{1,5}[-.\s]?\d{1,6}$/,
                                  message:
                                    "Please enter a valid phone number (e.g. +91 98765 43210 or (617) 123-4567)",
                                },
                                validate: {
                                  notAllZeros: value =>
                                    !/^0+$/.test(value.replace(/\D/g, "")) ||
                                    "Mobile number cannot be all zeros",
                                  minDigits: value => {
                                    const digits = value.replace(/\D/g, "");
                                    return digits.length >= 10 || "Please enter at least 10 digits";
                                  },
                                },
                                maxLength: {
                                  value: 20,
                                  message:
                                    "Please enter no more than 20 characters",
                                },
                              })}
                              onKeyUp={() => trigger("mobile_phone")}
                            />
                            {errors.mobile_phone && (
                              <small className="text-danger">
                                {errors.mobile_phone.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="address">Address</label>
                          </Col>
                          <Col xl={9}>
                            <div
                              className="companie-add"
                              style={{ position: "relative" }}
                            >
                              <InputTextarea
                                id="address"
                                value={address}
                                readOnly
                                placeholder="Enter address"
                                rows={3}
                                cols={20}
                                className="w-full"
                              />
                              <i
                                className="pi pi-pencil"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "70%",
                                  transform: "726px(-50%)",
                                  color: "#6c757d",
                                  cursor: "pointer",
                                }}
                                 onClick={() => {
    setTempStreet1(street1);
    setTempStreet2(street2);
    setTempPostalCode(postalCode);
    setTempSelectedCountry(selectedCountry);
    setTempSelectedState(selectedState);
    setTempSelectedCity(selectedCity);
    setTempSelectedLabel1(selectedLabel1);
    setVisible(true);
  }}
                              ></i>
                              <Dialog
                                header="Edit Address"
                                className="address-popup"
                                visible={visible}
                                onHide={() => setVisible(false)}
                                style={{ width: "30vw" }}
                                breakpoints={{
                                  "960px": "75vw",
                                  "641px": "100vw",
                                }}
                              >
                                <div className="card sidebardetails">
                                  <form>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="street1">
                                            Street 1
                                          </label>
                                          <InputText
                                            id="street1"
                                            value={tempStreet1}
  onChange={e => setTempStreet1(e.target.value)}
                                            placeholder="Enter Street 1"
                                            className="w-full"
                                          />
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="street2">
                                          Street 2
                                        </label>
                                        <InputText
  id="street2"
  value={tempStreet2}
  onChange={e => setTempStreet2(e.target.value)}
  placeholder="Enter Street 2 (Optional)"
  className="w-full"
/>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <label htmlFor="country">Country</label>
                                        <Dropdown
                                          id="country"
                                          value={tempSelectedCountry?.id}
                                          onChange={e => {
                                            const selected = addCountries.find(item => item.id === e.value);
                                            setTempSelectedCountry(selected || null);
                                            // Update form values
                                            setValue("country", selected?.id || null);
            }}

                                          options={addCountries}
                                          optionLabel="name"
                                          optionValue="id"
                                          filter
                                          placeholder="Select country"
                                          className="w-full"
                                        />
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="state">State</label>
                                        <Dropdown
                                          id="state"
                                          value={tempSelectedState?.id}
                                          onChange={e => {
              const selected = addStates.find(item => item.id === e.value);
              setTempSelectedState(selected || null);
              setValue("state", selected?.id || null); // Update form value
            }}

                                          options={addStates}
                                          optionLabel="name"
                                          optionValue="id"
                                          filter
                                          placeholder="Select state"
                                          className="w-full"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <label htmlFor="city">City</label>
                                        <Dropdown
                                          id="city"
                                          value={tempSelectedCity?.id}
                                          onChange={e => {
              const selected = addCities.find(item => item.id === e.value);
              setTempSelectedCity(selected || null);
              setValue("city", selected?.id || null); // Update form value
            }}

                                          options={addCities}
                                          optionLabel="name"
                                          optionValue="id"
                                          filter
                                          placeholder="Select city"
                                          className="w-full"
                                        />
                                      </Col>
                                      <Col lg={6}>
                                        <label htmlFor="postalCode">
                                          Postal Code
                                        </label>
                                        <InputText
                                          id="postalCode"
                                          value={tempPostalCode}
                                          onChange={e =>
                                            setTempPostalCode(e.target.value)
                                          }
                                          placeholder="Enter Postal Code"
                                          className="w-full"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={12}>
                                        <label htmlFor="label">Label</label>
                                        <Dropdown
                                          value={tempSelectedLabel1}
                                          onChange={e =>
                                            setTempSelectedLabel1(e.value)
                                          }
                                          options={addressLabels}
                                          optionLabel="label"
                                          optionValue="value"
                                          placeholder="Select a Label"
                                          className="w-full"
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <Button
  type="button"
  color="primary"
  className="btn btn-primary waves-light me-2"
  onClick={() => {
    setStreet1(tempStreet1);
    setStreet2(tempStreet2);
    setPostalCode(tempPostalCode);
    setSelectedCountry(tempSelectedCountry);
    setSelectedState(tempSelectedState);
    setSelectedCity(tempSelectedCity);
    setSelectedLabel1(tempSelectedLabel1);

    // Compose address for textarea (line by line, comma separated)
    const labelObj = addressLabels.find(l => l.value === tempSelectedLabel1);
    const addressLines = [
      tempStreet1,
      tempStreet2,
      tempSelectedCity?.name,
      tempSelectedState?.name,
      tempSelectedCountry?.name,
      tempPostalCode,
      labelObj?.label
    ].filter(Boolean).join(",\n");
    setAddress(addressLines);

    setVisible(false);
  }}
>
  <i className="pi pi-check me-1"></i> Ok
</Button>
                                      </Col>
                                    </Row>
                                  </form>
                                </div>
                              </Dialog>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="notes">Notes</label>
                          </Col>
                          <Col xl={9}>
                            <InputTextarea
                              id="notes"
                              rows={4}
                              cols={30}
                              placeholder="Enter notes..."
                              {...register("notes")}
                              className="w-full"
                              style={{ resize: "none" }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              
              </Col>
              <Col xl={4}>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">General Information</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="currentSalary"
                              className="block mb-2"
                            >
                              Current Salary
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="current_salary"
                              control={control}
                              render={({ field }) => (
                                <InputNumber
                                  inputId="current_salary"
                                  mode="currency"
                                  currency="INR"
                                  locale="en-IN"
                                  placeholder="Enter current annual salary"
                                  className="w-full"
                                  value={field.value ?? 0.0} // Default to 0.00 if null/undefined
                                  onValueChange={e =>
                                    field.onChange(e.value ?? 0.0)
                                  } // Ensure 0.00 on empty input
                                  useGrouping
                                  min={0}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="expectedSalary"
                              className="block mb-2"
                            >
                              Expected Salary
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="expected_salary"
                              control={control}
                              render={({ field }) => (
                                <InputNumber
                                  inputId="expected_salary"
                                  mode="currency"
                                  currency="INR"
                                  locale="en-IN"
                                  placeholder="Enter expected annual salary"
                                  className="w-full"
                                  value={field.value ?? 0.0}
                                  onValueChange={e =>
                                    field.onChange(e.value ?? 0.0)
                                  }
                                  useGrouping
                                  min={0}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="employeeType"
                              className="block mb-2"
                            >
                              Employee Type
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
  name="employee_type"
  control={control}
  render={({ field }) => (
    <Dropdown
      {...field}
      value={field.value}
      options={employeeTypeOptions}
      optionLabel="label"
      optionValue="value"
      placeholder="Select Employee Type"
      className="w-full border border-gray-400 rounded-md bg-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
      onChange={e => field.onChange(e.value)}
    />
  )}
/>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Date of Birth</label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="dob"
                              control={control}
                              render={({ field }) => {
                                const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    return (
      <Calendar
        value={field.value}
        onChange={e => {
          field.onChange(e.value);
          trigger("dob"); // Trigger validation on change
        }}
        dateFormat="yy-mm-dd"
        showIcon
        className="w-full"
        icon="pi pi-calendar"
        maxDate={yesterday} // <-- Only allow dates before today
      />
    );
  }}
/>
                            {errors.dob && (
                              <small className="text-danger">
                                {errors.dob.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">
                              Availability Date
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="availability_date"
                              control={control}
                              render={({ field }) => (
                                <Calendar
                                  value={field.value}
                                  onChange={e => field.onChange(e.value)}
                                  dateFormat="yy-mm-dd"
                                  showIcon
                                  className="w-full"
                                  icon="pi pi-calendar"
                                  minDate={
                                    new Date(new Date().setHours(0, 0, 0, 0))
                                  }
                                  // <-- explicitly add icon class
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Source <span className="text-danger">*</span></label>
                          </Col>
                          <Col xl={9}>
                            {/* <Controller
                              name="source"
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  value={field.value}
                                  onChange={e => field.onChange(e.value)}
                                  options={sourceOptions}
                                  optionLabel="label"
                                  placeholder="Select Source"
                                  className="w-full  p-inputtext"
                                />
                              )}
                            /> */}
                            <Controller
                              name="source"
                              control={control}
                              rules={{
                                required: "Source is required"
                              }}
                              render={({ field, fieldState }) => (
                                <>
                                  <select
                                    {...field}
                                    className={`form-select w-100 ${fieldState.error ? 'is-invalid' : ''}`}
                                  >
                                    <option value="">Select Source</option>
                                    {sourceOptions.map((option, index) => (
                                      <option key={index} value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                  {fieldState.error && (
                                    <small className="text-danger d-block mt-1">
                                      {fieldState.error.message}
                                    </small>
                                  )}
                                </>
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                              <label className="block mb-2">Referred By</label>
                            </Col>
                           <Col xl={9}>
                            <Controller
                              name="referred_by"
                              control={control}
                              rules={{ required: "Referred By is required" }}
                              render={({ field, fieldState }) => (
                                <>
                                  <select
                                    className={`form-select w-full ${fieldState.error ? "is-invalid" : ""}`}
                                    {...field} // includes value and onChange
                                  >
                                    <option value="">Select referrer</option>
                                    {referredByOptions.map((option) => (
                                      <option key={option.value} value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>

                                  {fieldState.error && (
                                    <small className="text-danger">{fieldState.error.message}</small>
                                  )}
                                </>
                              )}
                            />
                          </Col>

                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">Categories</label>
                          </Col>
                          <Col xl={9}>
                            <TreeSelect
                              value={selectedCategoryNode}
                              options={categoryNodes}
                              onChange={e => setSelectedCategoryNode(e.value)}
                              className="w-full"
                              placeholder="Select Category"
                              filter
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center d-none">
                          <Col xl={3}>
                            <label className="block mb-2">Groups</label>
                          </Col>
                          <Col xl={9}>
                            <TreeSelect
                              value={selectedGroupNode}
                              options={groupNodes}
                              onChange={e => setSelectedGroupNode(e.value)}
                              className="w-full"
                              placeholder="Select Group"
                              filter
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4}></Col>
                          <Col lg={4}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={12}>
                                <Controller
                                  name="relocation"
                                  control={control}
                                  render={({ field }) => (
                                    <div className="flex align-items-center">
                                      <Checkbox
                                        inputId="relocation"
                                        onChange={e =>
                                          field.onChange(e.checked)
                                        }
                                        checked={field.value}
                                        className="me-2"
                                      />
                                      <label
                                        htmlFor="relocation"
                                        className="mb-0"
                                      >
                                        Relocation
                                      </label>
                                    </div>
                                  )}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={4}>
                            <Row className="mt-2 align-items-center">
                              {/* <Col xl={3}>
                                <label htmlFor="private">Private</label>
                              </Col> */}
                              <Col xl={12}>
                                {/* <input
                                  type="checkbox"
                                  className="me-2"
                                  {...register("private")}
                                /> */}
                                <Controller
                                  name="private"
                                  control={control}
                                  render={({ field }) => (
                                    <div className="flex align-items-center">
                                      <Checkbox
                                        inputId="private"
                                        onChange={e =>
                                          field.onChange(e.checked)
                                        }
                                        checked={field.value}
                                        className="me-2"
                                      />
                                      <label htmlFor="private" className="mb-0">
                                        Private
                                      </label>
                                    </div>
                                  )}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Resume</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block mb-2">
                              Resume Attachment
                            </label>
                          </Col>
                          <Col xl={9} style={{ position: "relative" }}>
                            <div className="file-input-wrapper">
                              <small className="text-muted">
                                Eg: (jpeg, png, pdf, jpg, doc, docx) upto 5MB
                              </small>
                              <input
                                type="file"
                                ref={inputRef}
                                accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                className="form-control"
                                onChange={handleFileChange}
                                style={{
                                  paddingRight: "40px",
                                  lineHeight: "38px",
                                  boxSizing: "border-box",
                                }}
                              />
                              {fileData && (
                                <div
                                  className="form-control mt-2"
                                  style={{
                                    paddingRight: "40px",
                                    lineHeight: "38px",
                                    boxSizing: "border-box",
                                    backgroundColor: "#f8f9fa",
                                    color: "#495057",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {fileData.name}
                                </div>
                              )}
                              {fileData && (
                                <i
                                  className="pi pi-times"
                                  style={{
                                    position: "absolute",
                                    right: "20px",
                                    top: fileData ? "75%" : "50%", // Adjust position based on fileData presence
                                    transform: "translateY(-50%)",
                                    fontSize: "1.2rem",
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setFileData(null)
                                    setError("")
                                    inputRef.current.value = null
                                  }}
                                ></i>
                              )}
                            </div>
                            {error && (
                              <small className="text-danger">{error}</small>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Documents</h4>
                    <Row>
                      <Col xl={12}>
                        <DataTable
                          value={documents}
                          rows={5}
                          className="p-datatable-gridlines"
                          emptyMessage={
                            <div className="empty-message-custom">
                              No documents found.
                            </div>
                          }
                        >
                          <Column
                            field="selected_document.label"
                            header="Type"
                          />
                          <Column field="subject" header="Subject" />
                          <Column
                            field="file.name"
                            header="Attachment"
                            body={(rowData, { rowIndex }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>{rowData.file?.name || "No file"}</span>
      <button
        onClick={() => removeDocument(rowIndex)}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: 'red',
          cursor: 'pointer',
          fontSize: '16px',
          marginLeft: '10px'
        }}
      >
        <i className="pi pi-times"></i>
      </button>
    </div>
  )}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end mt-3">
                          <Button
                            color="primary"
                            className="btn waves-effect waves-light"
                            onClick={openAddDocumentDialog}
                          >
                            <i className="pi pi-plus me-1"></i> Add More
                          </Button>
                        </div>
                        <Dialog
                          header="Add Document"
                          visible={displayDialog}
                          onHide={closeAddDocumentDialog}
                          style={{ width: "30vw" }}
                        >
                          <form
                            onSubmit={e => {
                              e.preventDefault()
                              e.stopPropagation()
                              handleSubmitDoc(onSubmitDoc)(e)
                            }}
                          >
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block mb-2">
                                  Type <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="selected_document"
                                  control={controlDoc}
                                  rules={{
                                    required: "Document type is required ",
                                  }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      value={field.value}
                                      onChange={e => field.onChange(e.value)}
                                      options={documentTypes}
                                      optionLabel="label"
                                      className={`w-full ${
                                        errors.selected_document
                                          ? "p-invalid"
                                          : ""
                                      }`}
                                      placeholder="Select a Document"
                                    />
                                  )}
                                />
                                {errorsDoc.selected_document && (
                                  <small className="p-error">
                                    {errorsDoc.selected_document.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block mb-2">
                                  Subject <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  {...registerDoc("subject", {
                                    required: "Subject is required ",
                                    maxLength: {
                                      value: 100,
                                      message:
                                        "Subject cannot exceed 100 characters",
                                    },
                                  })}
                                  onKeyUp={() => trigger("subject")}
                                />
                                {errorsDoc.subject && (
                                  <small className="p-error">
                                    {errorsDoc.subject.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block mb-2">
                                  Attachment{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="file"
                                  control={controlDoc}
                                  rules={{
                                    required: "File attachment is required",
                                    validate: {
                                      validFileType: value =>
                                        (value &&
                                          [
                                            "application/pdf",
                                            "application/msword",
                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                          ].includes(value.type)) ||
                                        "Only PDF, Word documents, and image files (jpg, jpeg, png) are allowed",
                                      maxSize: value =>
                                        (value &&
                                          value.size <= 5 * 1024 * 1024) ||
                                        "File size should not exceed 5MB",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <FileUpload
                                      customUpload
                                      mode="basic"
                                      accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/jpg,image/png"
                                      maxFileSize={5 * 1024 * 1024}
                                      chooseLabel="Choose"
                                      uploadLabel="Upload"
                                      cancelLabel="Cancel"
                                      onSelect={async e => {
                                        const file = e.files[0]
                                        if (!file) return
                                        const base64 = await getBase64(file)
                                        field.onChange({
                                          name: file.name,
                                          base64,
                                          type: file.type,
                                          size: file.size,
                                        })
                                      }}
                                    />
                                  )}
                                />

                                {errorsDoc.file && (
                                  <small className="p-error">
                                    {errorsDoc.file.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12}>
                                <div className="d-flex justify-content-end mt-2">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="btn waves-effect waves-light"
                                    disabled={Object.keys(errorsDoc).length > 0}
                                  >
                                    Ok
                                  </Button>
                                  <Button
                                    type="button"
                                    color="secondary"
                                    className="btn waves-effect waves-light ml-2"
                                    onClick={closeAddDocumentDialog}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </form>
                        </Dialog>
                        <ConfirmDialog
                          visible={deleteEduVisible}
                          onHide={() => setDeleteEduVisible(false)}
                          message="Do you want to delete this education detail?"
                          header="Confirm Delete"
                          accept={() => {
                            const updated = educationDetails.filter((_, i) => i !== eduToDelete);
                            setEducationDetails(updated);
                            setDeleteEduVisible(false);
                          }}
                          reject={() => setDeleteEduVisible(false)}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
                            <Col xl={4}>
               <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Skills</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label htmlFor="primarySkills" className="mb-0">
                              Primary Skills
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="primary_skills"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  isMulti
                                  options={primarySkillsget}
                                  getOptionLabel={option => option.name}
                                  getOptionValue={option => option.id}
                                  className="w-full"
                                  placeholder="Select skills"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="secondary_skills"
                              className="block mb-2"
                            >
                              Secondary Skills
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="secondary_skills"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  isMulti
                                  options={primarySkillsget}
                                  getOptionLabel={option => option.name}
                                  getOptionValue={option => option.id}
                                  className="w-full"
                                  placeholder="Select skills"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label
                              htmlFor="other_skills"
                              className="block mb-2"
                            >
                              Other Skills
                            </label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="other_skills"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  isMulti
                                  options={primarySkillsget}
                                  getOptionLabel={option => option.name}
                                  getOptionValue={option => option.id}
                                  className="w-full"
                                  placeholder="Select skills"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                </Col>
              
              <Col xl={4} className="d-none">
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-3">Work Experience</h4>
                    <DataTable
                      value={workExperiences}
                      responsiveLayout="scroll"
                      className="mt-2"
                      emptyMessage={
                        <div className="empty-message-custom">
                          No work experience found.
                        </div>
                      }
                    >
                      <Column field="company_name" header="Company" />
                      <Column field="job_title" header="Job Title" />
                      <Column
                        field="start_date"
                        header="From Date"
                        body={rowData =>
                          rowData.start_date
                            ? new Date(rowData.start_date).toISOString().split('T')[0]
                            : "-"
                        }
                      />
                      <Column
                        field="end_date"
                        header="To Date"
                        body={rowData =>
                          rowData.end_date
                            ? new Date(rowData.end_date).toISOString().split('T')[0]
                            : "-"
                        }
                      />
                      <Column
                        header="Actions"
                        body={(rowData, { rowIndex }) => (
                          <div>
                            <i className="pi pi-pencil me-2" style={{ cursor: 'pointer' }} onClick={() => { setEditIndex(rowIndex); resetWork(workExperiences[rowIndex]); setShowDialog(true); }}></i>
                            <i className="pi pi-trash" style={{ cursor: 'pointer' }} onClick={() => { setWorkToDelete(rowIndex); setDeleteWorkVisible(true); }}></i>
                          </div>
                        )}
                      />
                    </DataTable>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        color="primary"
                        className="btn waves-effect waves-light"
                        onClick={() => {
                          setShowDialog(true)
                          setFormValues({
                            company_name: "",
                            website: "",
                            job_title: "",
                            start_date: null,
                            end_date: null,
                            description: "",
                          })
                          resetWork()
                          setEditIndex(null)
                        }}
                      >
                        <i className="pi pi-plus me-1"></i> Add More
                      </Button>
                    </div>
                    <Dialog
                      header={
                        editIndex !== null
                          ? "Edit Work Experience"
                          : "Add Work Experience"
                      }
                      visible={showDialog}
                      style={{ width: "30vw" }}
                      onHide={() => {
                        setShowDialog(false)
                        resetWork()
                        setEditIndex(null)
                      }}
                    >
                      <form
                        onSubmit={e => {
                          e.preventDefault() // Prevent event propagation
                          e.stopPropagation() // Stop event from bubbling to parent form
                          handleSubmitWork(data => {
                            if (editIndex !== null) {
                              const updatedExperiences = [...workExperiences]
                              updatedExperiences[editIndex] = data
                              setWorkExperiences(updatedExperiences)
                              triggerAlert("success", "Success", "Work experience updated successfully.")
                            } else {
                              setWorkExperiences([...workExperiences, data])
                              triggerAlert("success", "Success", "Work experience added successfully.")
                            }
                            resetWork()
                            setShowDialog(false)
                            setEditIndex(null)
                          })(e)
                        }}
                      >
                        <Row className="mb-2">
                          <Col xl={12}>
                            <label htmlFor="company" className="block">
                              Company <span className="text-danger">*</span>
                            </label>
                            <InputText
                              className="w-full"
                              {...registerWork("company_name", {
                                required: "Company name is required ",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z0-9\s&,-]*$/,
                                  message:
                                    "Company name must start with a letter and contain only letters, numbers, spaces, &, -, or ,",
                                },
                                maxLength: {
                                  value: 100,
                                  message:
                                    "Company name cannot exceed 100 characters",
                                },
                              })}
                              onKeyUp={() => trigger("company_name")}
                            />
                            {errorsWork.company_name && (
                              <small className="p-error">
                                {errorsWork.company_name.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col xl={12}>
                            <label htmlFor="website" className="block">
                              Website <span className="text-danger">*</span>
                            </label>
                            <InputText
                              className="w-full"
                              {...registerWork("website", {
                                required: "Website is required ",
                                pattern: {
                                  value:
                                    /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                                  message:
                                    "Please enter a valid URL (e.g., https://example.com)",
                                },
                              })}
                              onKeyUp={() => trigger("website")}
                            />
                            {errorsWork.website && (
                              <small className="p-error">
                                {errorsWork.website.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col xl={12}>
                            <label htmlFor="jobTitle" className="block">
                              Job Title <span className="text-danger">*</span>
                            </label>
                            <InputText
                              className="w-full"
                              {...registerWork("job_title", {
                                required: "Job title is required ",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z0-9\s&,-]*$/,
                                  message:
                                    "Job title must start with a letter and contain only letters, numbers, spaces, &, -, or ,",
                                },
                                maxLength: {
                                  value: 100,
                                  message:
                                    "Job title cannot exceed 100 characters",
                                },
                              })}
                              onKeyUp={() => trigger("job_title")}
                            />
                            {errorsWork.job_title && (
                              <small className="p-error">
                                {errorsWork.job_title.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col xl={12}>
                            <label htmlFor="fromDate" className="block">
                              From Date <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="start_date"
                              control={controlWork}
                              rules={{
                                required: "Start date is required",
                                validate: {
                                  notFuture: value => {
                                    const val = new Date(value)
                                    return (
                                      val <= new Date() ||
                                      "Start date cannot be in the future"
                                    )
                                  },
                                },
                              }}
                              render={({ field }) => (
                                <Calendar
                                  value={field.value}
                                  onChange={e => {
                                    field.onChange(e.value)
                                    trigger("start_date") // ✅ trigger validation on change
                                    trigger("end_date") // ✅ optionally revalidate end_date too
                                  }}
                                  showIcon
                                  className="w-full"
                                  dateFormat="yy-mm-dd"
                                  maxDate={new Date()}
                                  icon="pi pi-calendar"
                                />
                              )}
                            />
                            {errorsWork.start_date && (
                              <small className="p-error">
                                {errorsWork.start_date.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col xl={12}>
                            <label htmlFor="toDate" className="block">
                              To Date <span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="end_date"
                              control={controlWork}
                              rules={{
                                required: "End date is required",
                                validate: {
                                  notFuture: value => {
                                    const val = new Date(value)
                                    return (
                                      val <= new Date() ||
                                      "End date cannot be in the future"
                                    )
                                  },
                                  afterStartDate: value => {
                                    if (!value || !watchedStartDate) return true
                                    return (
                                      new Date(value) >=
                                        new Date(watchedStartDate) ||
                                      "End date must be on or after start date"
                                    )
                                  },
                                },
                              }}
                              render={({ field }) => (
                                <Calendar
                                  value={field.value}
                                  onChange={e => {
                                    field.onChange(e.value)
                                    trigger("end_date")
                                  }}
                                  showIcon
                                  className="w-full"
                                  dateFormat="yy-mm-dd"
                                  maxDate={new Date()}
                                  minDate={
                                    watchedStartDate
                                      ? new Date(watchedStartDate)
                                      : null
                                  }
                                  disabled={!watchedStartDate}
                                  icon="pi pi-calendar"
                                />
                              )}
                            />

                            {errorsWork.end_date && (
                              <small className="p-error">
                                {errorsWork.end_date.message}
                              </small>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col xl={12}>
                            <div className="d-flex justify-content-end mt-2">
                              <Button
                                type="submit"
                                color="primary"
                                className="btn waves-effect waves-light"
                                disabled={Object.keys(errorsWork).length > 0}
                              >
                                {editIndex !== null ? "Update" : "Ok"}
                              </Button>
                              <Button
                                type="button"
                                color="secondary"
                                className="btn waves-effect waves-light ml-2"
                                onClick={() => {
                                  setShowDialog(false)
                                  resetWork()
                                  setEditIndex(null)
                                }}
                              >
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </Dialog>
                    <ConfirmDialog
                      visible={deleteWorkVisible}
                      onHide={() => setDeleteWorkVisible(false)}
                      message="Do you want to delete this work experience?"
                      header="Confirm Delete"
                      accept={() => {
                        const updated = workExperiences.filter((_, i) => i !== workToDelete);
                        setWorkExperiences(updated);
                        setDeleteWorkVisible(false);
                      }}
                      reject={() => setDeleteWorkVisible(false)}
                    />
                    <ConfirmDialog />
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-3">Education Details</h4>
                    <Row>
                      <Col xl={12}>
                        <DataTable
                          value={educationDetails}
                          showGridlines
                          emptyMessage={
                            <div className="empty-message-custom">
                              No education details found.
                            </div>
                          }
                        >
                          <Column field="degree" header="Degree" />
                          <Column field="school_name" header="School" />
                          <Column
                            field="field_of_study"
                            header="Field of Study"
                          />
                          {/* <Column field="grade" header="Grade" />
                          <Column field="start_year" header="Start Year" />
                          <Column field="start_month" header="Start Month" /> */}
                          <Column field="end_year" header="End Year" />
                          {/* <Column field="end_month" header="End Month" /> */}
                          <Column
                            header="Actions"
                            body={(rowData, { rowIndex }) => (
                              <div>
                                <i className="pi pi-pencil me-2" style={{ cursor: 'pointer' }} onClick={() => { setEditEduIndex(rowIndex); resetEduForm(educationDetails[rowIndex]); setIsDialogVisible(true); }}></i>
                                <i className="pi pi-trash" style={{ cursor: 'pointer' }} onClick={() => { setEduToDelete(rowIndex); setDeleteEduVisible(true); }}></i>
                              </div>
                            )}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end mt-3">
                          <Button
                            color="primary"
                            className="btn waves-effect waves-light"
                            onClick={() => { setEditEduIndex(null); setIsDialogVisible(true); }}
                          >
                            <i className="pi pi-plus me-1"></i> Add More
                          </Button>
                        </div>
                        <Dialog
                          header={editEduIndex !== null ? "Edit Education" : "Add Education"}
                          visible={isDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={() => {
                            setIsDialogVisible(false)
                            resetEduForm()
                            setEditEduIndex(null)
                          }}
                        >
                          <form
                            onSubmit={e => {
                              e.preventDefault()
                              e.stopPropagation()
                              handleSubmitEdu(data => {
                                if (editEduIndex !== null) {
                                  const updated = [...educationDetails]
                                  updated[editEduIndex] = data
                                  setEducationDetails(updated)
                                  triggerAlert("success", "Success", "Education detail updated successfully.")
                                } else {
                                  setEducationDetails(prev => [...prev, data])
                                  triggerAlert("success", "Success", "Education detail added successfully.")
                                }
                                resetEduForm()
                                setIsDialogVisible(false)
                                setEditEduIndex(null)
                              })(e)
                            }}
                          >
                            <div className="field">
                              <label className="block mb-2">
                                Degree <span className="text-danger">*</span>
                              </label>
                              {/* sais code */}
                              <Controller
                                name="degree"
                                control={eduControl}
                                rules={{
                                  required: "Degree is required ",
                                  pattern: {
                                    value: /^[A-Za-z0-9.,\-\/&() ]+$/,
                                    message:
                                      "Only letters, numbers, spaces, and . , - / & ( ) are allowed",
                                  },
                                }}
                                render={({ field }) => (
                                  <InputText
                                    {...field}
                                    placeholder="Enter Degree"
                                    className="w-full"
                                    onInput={e => {
                                      // Remove any character not in the allowed set
                                      e.target.value = e.target.value.replace(
                                        /[^A-Za-z0-9.,\-\/&() ]/g,
                                        ""
                                      )
                                      field.onChange(e) // update react-hook-form value
                                    }}
                                  />
                                )}
                              />
                              {eduErrors.degree && (
                                <small className="p-error">
                                  {eduErrors.degree.message}
                                </small>
                              )}
                            </div>
                            <div className="field mt-2">
                              <label className="block mb-2">
                                School <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="school_name"
                                control={eduControl}
                                rules={{ required: "School name is required" }}
                                render={({ field }) => (
                                  <InputText
                                    {...field}
                                    placeholder="Enter School"
                                    className="w-full"
                                  />
                                )}
                              />
                              {eduErrors.school_name && (
                                <small className="p-error">
                                  {eduErrors.school_name.message}
                                </small>
                              )}
                            </div>
                            <div className="field mt-2">
                              <label className="block mb-2">
                                Field of Study{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="field_of_study"
                                control={eduControl}
                                rules={{
                                  required: "Field of study is required",
                                }}
                                render={({ field }) => (
                                  <InputText
                                    {...field}
                                    placeholder="Enter Field of Study"
                                    className="w-full"
                                  />
                                )}
                              />
                              {eduErrors.field_of_study && (
                                <small className="p-error">
                                  {eduErrors.field_of_study.message}
                                </small>
                              )}
                            </div>
                            <div className="field mt-2">
                              <label className="block mb-2">
                                Grade <span className="text-danger">*</span>
                              </label>
                              <Controller
                                name="grade"
                                control={eduControl}
                                rules={{ required: "Grade is required" }}
                                render={({ field }) => (
                                  <InputText
                                    {...field}
                                    placeholder="Enter Grade"
                                    className="w-full"
                                  />
                                )}
                              />
                              {eduErrors.grade && (
                                <small className="p-error">
                                  {eduErrors.grade.message}
                                </small>
                              )}
                            </div>
                            <Row className="mt-2">
                              <Col xl={6}>
                                <label className="block mb-2">
                                  Start Year{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Controller
                                  name="start_year"
                                  control={eduControl}
                                  rules={{ required: "Start year is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      options={years}
                                      placeholder="Select Year"
                                      className="w-full"
                                    />
                                  )}
                                />
                                {eduErrors.start_year && (
                                  <small className="p-error">
                                    {eduErrors.start_year.message}
                                  </small>
                                )}
                              </Col>
                              <Col xl={6}>
                                <label className="block mb-2">
                                  Start Month{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Controller
                                  name="start_month"
                                  control={eduControl}
                                  rules={{
                                    required: "Start month is required",
                                  }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      options={months}
                                      placeholder="Select Month"
                                      className="w-full"
                                    />
                                  )}
                                />
                                {eduErrors.start_month && (
                                  <small className="p-error">
                                    {eduErrors.start_month.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2">
                              <Col xl={6}>
                                <label className="block mb-2">
                                  End Year{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Controller
                                  name="end_year"
                                  control={eduControl}
                                  rules={{
                                    required: "End year is required",
                                    validate: value => {
                                      const startYear = watchEdu("start_year") // ✅ Get start year
                                      if (startYear && value < startYear) {
                                        return "End year cannot be less than start year"
                                      }
                                      return true
                                    },
                                  }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      options={years}
                                      placeholder="Select Year"
                                      className="w-full"
                                    />
                                  )}
                                />
                                {eduErrors.end_year && (
                                  <small className="p-error">
                                    {eduErrors.end_year.message}
                                  </small>
                                )}
                              </Col>
                              <Col xl={6}>
                                <label className="block mb-2">
                                  End Month{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Controller
                                  name="end_month"
                                  control={eduControl}
                                  rules={{ required: "End month is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      {...field}
                                      options={months}
                                      placeholder="Select Month"
                                      className="w-full"
                                    />
                                  )}
                                />
                                {eduErrors.end_month && (
                                  <small className="p-error">
                                    {eduErrors.end_month.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={12}>
                                <div className="d-flex justify-content-end mt-2">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    className="btn waves-effect waves-light"
                                    disabled={Object.keys(eduErrors).length > 0}
                                  >
                                    {editEduIndex !== null ? "Update" : "Ok"}
                                  </Button>
                                  <Button
                                    type="button"
                                    color="secondary"
                                    className="btn waves-effect waves-light ml-2"
                                    onClick={() => {
                                      setIsDialogVisible(false)
                                      resetEduForm()
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </form>
                        </Dialog>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">Social Pages</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="align-items-center mt-2">
                          <Col xl={3}>
                            <label className="block">LinkedIn URL</label>
                          </Col>
                          <Col xl={9} style={{ position: "relative" }}>
                            <InputText
                              className="w-full"
                              style={{
                                paddingRight: "40px",
                                height: "38px",
                                lineHeight: "38px",
                                boxSizing: "border-box",
                              }}
                              {...register("linkedin_url")}
                            />
                            <i
                              className="pi pi-linkedin"
                              style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2rem",
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                              }}
                            ></i>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Facebook URL</label>
                          </Col>
                          <Col xl={9} style={{ position: "relative" }}>
                            <InputText
                              className="w-full"
                              style={{
                                paddingRight: "40px",
                                height: "38px",
                                lineHeight: "38px",
                                boxSizing: "border-box",
                              }}
                              {...register("facebook_url")}
                            />
                            <i
                              className="pi pi-facebook"
                              style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2rem",
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                              }}
                            ></i>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Twitter URL</label>
                          </Col>
                          <Col xl={9} style={{ position: "relative" }}>
                            <InputText
                              className="w-full"
                              style={{
                                paddingRight: "40px",
                                height: "38px",
                                lineHeight: "38px",
                                boxSizing: "border-box",
                              }}
                              {...register("x_url")}
                            />
                            <i
                              className="pi pi-twitter"
                              style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2rem",
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                              }}
                            ></i>
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Indeed URL</label>
                          </Col>
                          <Col xl={9} style={{ position: "relative" }}>
                            <InputText
                              className="w-full"
                              style={{
                                paddingRight: "40px",
                                height: "38px",
                                lineHeight: "38px",
                                boxSizing: "border-box",
                              }}
                              {...register("indeed_url")}
                            />
                            <i
                              className="pi pi-info"
                              style={{
                                position: "absolute",
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2rem",
                                color: "#666",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "24px",
                                height: "24px",
                              }}
                            ></i>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card className="bg-form">
                  <CardBody>
                    <h4 className="card-title mb-2">System Fields</h4>
                    <Row>
                      <Col xl={12}>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Create Date</label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="created_at"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <Calendar
                                  // showTime
                                  value={value}
                                  onChange={e => onChange(e.value)}
                                  dateFormat="yy-mm-dd"
                                  // hourFormat="24"
                                  showIcon
                                  className="w-full"
                                  disabled
                                  icon="pi pi-calendar" // <-- explicitly add icon class
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Edit Date</label>
                          </Col>
                          <Col xl={9}>
                            <Controller
                              name="updated_at"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <Calendar
                                  // showTime
                                  value={value}
                                  onChange={e => onChange(e.value)}
                                  dateFormat="yy-mm-dd"
                                  // hourFormat="24"
                                  showIcon
                                  className="w-full"
                                  disabled
                                  icon="pi pi-calendar" // <-- explicitly add icon class
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Created By</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              id="userIds"
                              value={uniqueUserId}
                              disabled
                              placeholder=""
                              className="block w-full"
                            />
                          </Col>
                        </Row>
                        {/* <Row className="mt-2 align-items-center">
                          <Col xl={3}>
                            <label className="block">Last Activity Type</label>
                          </Col>
                          <Col xl={9}>
                            <InputText
                              className="w-full"
                              {...register("last_activity_type")}
                              onKeyUp={() => trigger("last_activity_type")}
                            />
                          </Col>
                        </Row> */}
                        {/* <Row className="mt-2 align-items-center">
                          <Row className="mt-2 align-items-center">
                            <Col xl={3}>
                              <label className="block">Last Activity Date</label>
                            </Col>
                            <Col xl={9}>
                              <Controller
                                name="last_activity_date"
                                control={control}
                                rules={{
                                  validate: {
                                    validFormat: value =>
                                      !value ||
                                      /^\d{4}-\d{2}-\d{2}$/.test(formatDateTime(value, "yyyy-mm-dd")) ||
                                      true, // Return true to suppress error display
                                  },
                                }}
                                render={({ field }) => (
                                  <Calendar
                                    value={field.value}
                                    onChange={e => {
                                      field.onChange(e.value);
                                      trigger("last_activity_date"); // Trigger validation on change
                                    }}
                                    dateFormat="yy-mm-dd"
                                    showIcon
                                    className="w-full"
                                    icon="pi pi-calendar" // <-- explicitly add icon class
                                  />
                                )}
                              />
                            </Col>
                          </Row>
                        </Row> */}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className="align-items-center mb-3">
              <Col md={12}>
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2"
                    disabled={isLoading}
                  >
                    Save
                  </Button>
                  <Link to="/all_candidates">
                    <Button
                      color="secondary"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Cancel <i className="pi pi-times me-1"></i>
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </form>
        </Container>
      </div>)}
      
    </React.Fragment>
  )
}

export default CandidateEditFormExtra
